export default {
  path: 'Paihuofeedback',
  component: () => import(/* webpackChunkName: "category-list" */ '@/pages/individual/Paihuofeedback'),
  meta: {title: '派活反馈'}
  // children: [{
  //   path: ':invoicing_id/view',
  //   component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/CreateEdit'),
  //   meta: {
  //     title: '个体户发票代开详情'
  //   },
  // }]
}